var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"facet-item-text cursor-pointer flex-grow pl-1",attrs:{"for":_vm.itemId || _vm.item.id,"qaid":_vm.qaid}},[_c('em',[_vm._v(_vm._s(_vm.item.displayText))])])}
var staticRenderFns = []

export { render, staticRenderFns }